import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { AppMainComponent } from 'src/app/app.main.component';
import { LoginService } from 'src/app/login/login.service';
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-myargic',
  templateUrl: './myargic.component.html',
  styleUrls: ['./myargic.component.scss'],
  providers:[MessageService]
})
export class MyargicComponent implements OnInit {

    constructor(public app: AppComponent, public appMain: AppMainComponent, public loginService: LoginService, private messageService: MessageService)
    {


    }


  ngOnInit(): void {
  }
  onConfirm() {
    this.messageService.clear('tc');
}

onReject() {
    this.messageService.clear('c');
}

goToTC(){
     this.messageService.add({
         key: "tc",
         severity: "error",
         summary: "Not available yet",
         detail: "Under construction - To determine",
    });
}

goToNotAllowed(){
    this.messageService.add({
        key: "tc",
        severity: "error",
        summary: "This function is not allowed on the Argic testing environment.",
        detail: "This function is not allowed on the Argic testing environment.",
   });
}


}
